<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				resource: 'departments',
				modal: {
					selector: 'department-create',
				},
				statuses: null,
				data: {
					name: null,
					status_id: 2,
					description: null,
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getStatuses()
			},
			getStatuses: function() {
				this.$http.get('admin/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			clearData: function() {
				this.data.name = null
				this.data.status_id = 2
				this.data.description = null
			},
			validateData() {
				if(this.data.name) {
					return true
				} else {
					return false
				}
			},
			store: function() {
				if(this.validateData()) {
					var loading = Ladda.create(document.querySelector('#btn-store'))
					loading.start()
					var api = 'admin/'+this.resource
					this.$http.post(api, this.data)
						.then(response => {
							loading.stop();
							this.close()
							this.clearData()
							this.$emit('reload')
							swal({
								title: response.body.title,
								text: response.body.text,
								type: response.body.type,
							})
						}).catch(function(response) {
							console.log(response)
							loading.stop();
						})
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/departments/views/Create.vue